import gql from 'graphql-tag';

export default gql`
mutation deleteTeam($obj: DeleteTeamInput!) {
  deleteTeam(object: $obj) {
    deletedTeam
  }
}
`;
